/******/ (() => {
  // webpackBootstrap
  var __webpack_exports__ = {};
  /* eslint-disable */
  window.PXUTheme.jsHeader = {
    init: function ($section) {
      // Add settings from schema to current object
      window.PXUTheme.jsHeader = $.extend(
        this,
        window.PXUTheme.getSectionData($section)
      );

      // Selectors
      this.$el = $('#header');
      this.$menuToggle = this.$el.find('.header__menu-toggle');
      let announcementHeight = $('.announcement-sticky-wrapper').height();

      // Overlaid header
      if (this.enable_overlay === true && isScreenSizeLarge()) {
        this.updateOverlayStyle(this.sectionUnderlayIsImage());
      }

      // Sticky header
      // Made mobile menu load below 1200px - dagoodma 2025/02/03
      if (
        this.enable_sticky === true &&
        window.PXUTheme.media_queries.xlarge.matches
      ) {
        //  isScreenSizeLarge()) {
        this.enableSticky(announcementHeight);

        $(window).on('resize', () => {
          this.enableSticky(announcementHeight);

          // Hide mega menu when resizing on desktop - dagoodma 2025/02/04
          if ($('.mega-menu').length > 0) {
            window.PXUTheme.jsMegaMenu.hideMenu();
          }
        });
      }

      // Moved QAB top bar into theme code - dagoodma 2025/02/0
      var mobileTopBar = false;
      if (!window.PXUTheme.media_queries.xlarge.matches) {
        this.switchToMobileTopBar();
        mobileTopBar = true;
      }
      $(window).on('resize', () => {
        if (window.PXUTheme.media_queries.xlarge.matches) {
          if (mobileTopBar) {
            this.switchToDesktopTopBar();
            mobileTopBar = false;
          }
        } else {
          if (!mobileTopBar) {
            this.switchToMobileTopBar();
            mobileTopBar = true;
          }
        }
      });

      if (
        this.header_layout == 'centered' ||
        this.header_layout == 'search_focus'
      ) {
        this.$menuToggle.on('click', () => {
          this.showStickyMenu();
        });
      } else if (this.header_layout == 'vertical') {
        $section.find('.header-sticky-wrapper').stick_in_parent();
        this.addOffScreenDropdownCheck();
      }

      if ($('.mega-menu').length > 0) {
        window.PXUTheme.jsMegaMenu.init($section);
      }

      // Made mobile menu load below 1200px - dagoodma 2025/02/03
      //if (!isScreenSizeLarge()){
      if (!window.PXUTheme.media_queries.xlarge.matches) {
        this.unload();
        window.PXUTheme.mobileMenu.init();
      }

      $('.search-overlay__close').on('click', function () {
        window.PXUTheme.jsHeader.hideSearch();
      });

      $(document).on('click', '[data-show-search-trigger]', function () {
        window.PXUTheme.jsHeader.showSearch();
      });

      if (
        isScreenSizeLarge() ||
        !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        $(
          '.dropdown-click--true .header__link:not(.primary-brand, .primary-logo)'
        ).on('click touchstart', function (e) {
          var $this = $(this);
          window.PXUTheme.jsHeader.toggleMenuClick(e, $this);
        });
      }

      if (this.dropdown_click === false) {
        $('.navbar-item').on('mouseleave', function () {
          window.PXUTheme.jsHeader.collapseSubmenu($(this));
        });

        /* Added by dagoodma of CampaignTrip - 3/2/24.
         * Disable navigate on link click for desktop menu.
         */
        $('.navbar-link.header__link').on('click touchstart', function (e) {
          var $this = $(this);
          // Prevent link load on click
          e.preventDefault();
          window.PXUTheme.jsHeader.toggleMenuClick(
            e,
            $this
          ); /* Fixed tablet click - dagoodma 3/8/2024 */
        });
      }

      $(document).on('keydown', '[data-show-search-trigger]', function (e) {
        if (e.which === 13) {
          window.PXUTheme.jsHeader.showSearch();
        }
      });

      if (window.PXUTheme.theme_settings.search_layout == 'overlay') {
        document.body.addEventListener('click', e => {
          if (e.target === document.querySelector('[data-site-overlay]')) {
            window.PXUTheme.jsHeader.hideSearch();
          }
        });
      }
    },
    switchToMobileTopBar: function () {
      var header = document.getElementById('header');
      var desktopPlaceholder = document.getElementById('qab_placeholder');
      var mobilePlaceholder = document.getElementById('qab_placeholder2');
      if (!mobilePlaceholder) {
        console.log(
          'Cant switch to mobile top bar, mobile placeholder not found.'
        );
        return;
      }

      // Create a desktop placeholder for switching back
      var divAbove = document.createElement('div');
      divAbove.id = 'qab_placeholder_desktop';
      header.insertBefore(divAbove, header.firstChild);

      mobilePlaceholder.replaceWith(desktopPlaceholder);
      console.log('Switched to mobile top bar.');
    },
    switchToDesktopTopBar: function () {
      var header = document.getElementById('header');
      var mobileHeader = document.getElementById('mobile-header');
      var desktopPlaceholder = document.getElementById(
        'qab_placeholder_desktop'
      );
      var mobilePlaceholder = document.getElementById('qab_placeholder');
      if (!desktopPlaceholder) {
        console.log(
          'Can switch back to desktop top bar, desktop placeholder not found.'
        );
        return;
      }
      // Create a mobile placeholder for switching back
      var divAbove = document.createElement('div');
      divAbove.id = 'qab_placeholder2';
      mobileHeader.insertBefore(divAbove, mobileHeader.firstChild);

      desktopPlaceholder.replaceWith(mobilePlaceholder);
      console.log('Switched back to desktop top bar.');
    },
    toggleMenuClick: function (e, $this) {
      var $parentWrap = $this.parents('.has-dropdown, .has-mega-menu');
      var $flatNavLink = $(
        '.navbar-item.header__item:not(.has-mega-menu):not(.has-dropdown)'
      );

      if ($parentWrap.length > 0 && !$parentWrap.hasClass('is-opened')) {
        /* Added by dagoodma of CampaignTrip - 3/2/24.
         * Disable navigate on link click for desktop menu.
         */
        // Prevent link on first click
        e.preventDefault();

        // Close all dropdowns & mega menu
        $('.has-dropdown, .has-mega-menu').removeClass('is-opened');
        $('.mega-menu__section').removeClass('is-active');

        // Open selected dropdown/mega menu
        $parentWrap.addClass('is-opened');
        $parentWrap.data('clicked', 'true');

        /* Fixed tablet click, escape key - dagoodma 3/8/2024 */
        var $megaMenu = $parentWrap.find('.mega-menu__section');
        if ($megaMenu.length > 0) {
          $megaMenu.addClass('is-active');
          $('body').addClass('mega-menu__is-open');
        }
      } else if ($flatNavLink.length > 0) {
        /* Added by dagoodma of TESTLAB on 9/8/25.
         * If the menu item clicked is a flat nav link, then don't override the default behavior.
         */
        // Force navigate:
        const $link = $this.attr('href')
          ? $this
          : $this.closest('.navbar-item').find('a.header__link').first();
        if ($link.length > 0) {
          const href = $link.attr('href');
          // Only navigate if href exists and is not undefined, null, or just a hash
          if (href && href !== '#' && href !== 'undefined') {
            window.location.href = href;
          }
        }
      } else {
        // Close all dropdowns & mega menu
        $('.has-dropdown, .has-mega-menu').removeClass('is-opened');
        $('.mega-menu__section').removeClass('is-active');
        $('body').removeClass('mega-menu__is-open');
      }

      // Close dropdown if click anywhere outside dropdown menu
      $(window).on('click', function (e) {
        if (
          $(e.target).closest('.header__link, .navbar-dropdown').length === 0
        ) {
          $('.has-dropdown, .has-mega-menu').removeClass('is-opened');
          $('.mega-menu__section').removeClass('is-active');
          window.PXUTheme.jsHeader.collapseSubmenu($('.navbar-item'));
        }
      });
    },
    collapseSubmenu: function (el) {
      $(el).find('.has-submenu input').prop('checked', false);
    },
    showStickyMenu: function () {
      this.$menuToggle.toggleClass('is-active');
      this.$el.find('.sticky-menu-wrapper').toggleClass('is-visible');
    },
    hideStickyMenu: function () {
      this.$menuToggle.removeClass('is-active');
      this.$el.find('.sticky-menu-wrapper').removeClass('is-visible');
    },
    disableSticky: function () {
      let $stickyEl = $('#header');

      $stickyEl.unstick();
      $stickyEl.removeClass('sticky--enabled');

      setTimeout(function () {
        $stickyEl.css('height', 'auto');
      }, 250);
    },
    enableSticky: function (offset) {
      let $stickyEl = this.$el;

      $stickyEl.addClass('sticky--enabled');

      $stickyEl
        .sticky({
          wrapperClassName: 'header-sticky-wrapper',
          zIndex: 70,
          topSpacing: offset || 0
        })
        .on('sticky-start', () => {
          let headerHeight;
          let announcementHeight;

          // Hide the mini cart for centered header layout
          if (window.PXUTheme.theme_settings.header_layout == 'centered') {
            $(
              '.top-bar [data-ajax-cart-trigger] [data-ajax-cart-mini_cart]'
            ).css('display', 'none');
          }

          // Get header height is sticky enabled
          if (
            window.PXUTheme.jsHeader.enable_sticky == true &&
            window.PXUTheme.theme_settings.header_layout != 'vertical'
          ) {
            headerHeight = window.PXUTheme.jsHeader.getHeaderHeight();
          }

          // Get announcement height is sticky enabled
          if (
            typeof window.PXUTheme.jsAnnouncementBar !== 'undefined' &&
            window.PXUTheme.jsAnnouncementBar.enable_sticky == true &&
            window.PXUTheme.theme_settings.header_layout != 'vertical'
          ) {
            announcementHeight =
              window.PXUTheme.jsAnnouncementBar.getAnnouncementHeight();
          } else {
            announcementHeight = 0;
          }

          let totalHeight = headerHeight + announcementHeight;
          $stickyEl
            .parent()
            .parent()
            .find('.search-overlay')
            .addClass('sticky-search')
            .css('top', totalHeight + 'px');

          if (
            this.enable_overlay === true &&
            this.sectionUnderlayIsImage() === true
          ) {
            $stickyEl.parent().addClass('has-overlaid-header');
            this.disableOverlayStyle();
          } else if (this.enable_overlay === true) {
            this.disableOverlayStyle();
          }
        })
        .on('sticky-end', () => {
          $stickyEl
            .parent()
            .parent()
            .find('.search-overlay')
            .removeClass('sticky-search')
            .css('top', '100%');

          // Safety timeout for logo width transition which can throw calculated height off
          setTimeout(() => {
            $stickyEl.sticky('update');
          }, 250);

          // Un-hide the mini cart when scrolled back to the top
          if (window.PXUTheme.theme_settings.header_layout == 'centered') {
            $(
              '.top-bar [data-ajax-cart-trigger] [data-ajax-cart-mini_cart]'
            ).css('display', 'block');
          }

          this.$el.find('.sticky-menu-wrapper').removeClass('is-visible');
          this.$menuToggle.removeClass('is-active');

          if (
            this.enable_overlay === true &&
            this.sectionUnderlayIsImage() === true
          ) {
            this.updateOverlayStyle(this.sectionUnderlayIsImage());
          }
        });
    },
    disableOverlayStyle: function () {
      $('[data-enable_overlay]').attr('data-enable_overlay', false);
    },
    enableOverlayStyle: function () {
      $('[data-enable_overlay]').attr('data-enable_overlay', true);
    },
    updateOverlayStyle: function (overlayBoolean) {
      $('[data-enable_overlay]').attr('data-enable_overlay', overlayBoolean);
    },
    sectionUnderlayIsImage: function () {
      let $firstSection = $('[data-check-for-order=true]')
        .find('[id^=shopify-section]')
        .first();

      // Check whether the first element has class to indicate it should be under header when overlay is enabled
      if (
        $firstSection.hasClass('overlaid-header-option') &&
        $.trim($firstSection.html()).length > 0
      ) {
        return true;
      } else {
        return false;
      }
    },
    showSearch: function () {
      $('[data-show-search-trigger]').addClass('is-active');

      if (window.PXUTheme.theme_settings.search_layout == 'overlay') {
        $('[data-search-type="overlay"]').addClass('is-opened');
        $('.search-form .search__fields input[type="text"]')[0].focus();
        window.PXUTheme.predictiveSearch.lockBodyScroll();
      } else {
        /* Customize close button to match slideout cart - dagoodma 2026/01/12 */
        //$.fancybox.defaults.closeTpl = '<button type="button" data-fancybox-close="" class="fancybox-button fancybox-close-small search-popup__close" title="Close" aria-label="Close Search"><i aria-hidden="true" class="fal fa-times"></i> <span class="sr-only">Close Search</span></button>';
        $.fancybox.open($('.js-search-popup'), {
          baseClass: 'search__lightbox',
          hash: false,
          infobar: false,
          toolbar: false,
          loop: true,
          smallBtn: false,
          mobile: {
            preventCaptionOverlap: false,
            toolbar: false
          },
          touch: false,
          beforeClose: function () {
            $('[data-show-search-trigger]').removeClass('is-active');
          },
          afterShow: function () {
            // Set the cursor at the end of the input field for better UX,
            // otherwise it may be at the beginning of the input field when the input gets focus.
            const searchInputEl = $(
              '.search-form .search__fields input[type="text"]'
            )[0];
            const searchTermLength = searchInputEl.value.length;
            searchInputEl.setSelectionRange(searchTermLength, searchTermLength);
          }
        });
      }
    },
    hideSearch: function () {
      $('[data-show-search-trigger]').removeClass('is-active');
      if (
        window.PXUTheme.theme_settings.search_layout == 'overlay' ||
        window.PXUTheme.theme_settings.header_layout == 'search_focus' ||
        window.PXUTheme.theme_settings.header_layout == 'vertical'
      ) {
        $('[data-autocomplete-true] .search__results-wrapper').hide();
        $('[data-search-type="overlay"]').removeClass('is-opened');
        window.PXUTheme.predictiveSearch.unlockBodyScroll();
      } else {
        $.fancybox.close(
          $(
            '[data-search-type="' +
              window.PXUTheme.theme_settings.search_layout +
              '"]'
          )
        );
      }
    },
    addOffScreenDropdownCheck: function () {
      $('.navbar-item.has-dropdown--vertical').hover(function () {
        const dropdown = $(this),
          menu = dropdown.find('.navbar-dropdown');

        menu.removeClass('navbar-dropdown--fix-offscreen');

        if (menu.is(':off-screen')) {
          menu.addClass('navbar-dropdown--fix-offscreen');
        }
      });
    },
    getHeaderHeight: function () {
      const headerHeight = $('.header-section').outerHeight() || 0;

      return headerHeight;
    },
    unload: function ($section) {
      $('.has-overlaid-header').removeClass('has-overlaid-header');
      $('[data-show-search-trigger]').off();
      $('.navbar-item').off();
      $('#header').off();
      $('.dropdown-click--true .header__link').off();
      this.$menuToggle.off();
      this.disableSticky();
      this.disableOverlayStyle();
    }
  };

  /* Rebuy SmartCart integration - dagoodma 3/8/2024 */
  // Add event listener for Rebuy (SmartCart to update the cart icon item count)
  document.addEventListener('rebuy:cart.change', event => {
    //console.log('Detected rebuy:cart.change event: ', event.detail);

    if (!!window.Rebuy && !!window.Rebuy.SmartCart) {
      const Cart = window.Rebuy.Cart;
      const cnt = Cart.itemCount();
      // Update the cart icon item count
      //const cartIconItemCountSel = document.querySelector('[data-bind="itemCount"]');
      var cartIconCount = jQuery('[data-bind="itemCount"]');
      if (!!cartIconCount) {
        cartIconCount.text(cnt);
        console.log('Updated cart icon item count to: ', cnt);

        // Add the .has-cart-count class if it's missing
        // Note: needed to use jquery here since iPhone with Safari < 5.1 doesn't support classlist!??!
        var cartIcon = jQuery('.header-cart');
        if (!!cartIcon && cnt > 0) {
          cartIcon.addClass('has-cart-count');
        } else {
          console.log('Failed to find cart icon, or count was zero.');
        }
      } else {
        console.error('Failed to find and update the cart icon item count.');
      }
    } else {
      console.log(
        'No Rebuy SmartCart found, skipping updating cart icon item count.'
      );
    }
  });

  /******/
})();
